import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';
import ordkjedeAvatar from './assets/ordkjede.png';

// import './styles.scss';

import {
	goToNextStep,
	setTestStepAnswers,
	setIsSendingTestResultsToFalse,
} from 'actions/index';

import {TEST_STEPS} from 'constants/index';

import Intro from './Intro';
import Tutorial from './Tutorial';
import Test from './Test';

const subSteps = [Intro, Tutorial, Test];

class Ordkjedetesten extends React.Component {
	constructor(props) {
		super(props);

		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			isSubmitting: false,
			currentSubstepIndex: 0,
			showAvatar: true,
		};
	}

	handleNextSubstep(results) {
		const {currentSubstepIndex} = this.state;
		const {candidateGrade} = this.props;

		const {
			onGoToNextStep,
			onSetTestStepAnswers,
			onSetIsSendingTestResultsToFalse,
		} = this.props;

		const isLastStep = currentSubstepIndex === subSteps.length - 1;

		if (isLastStep) {
			const resultKeys = Object.keys(results);
			const formattedResults = resultKeys.map((id) => {
				const value = results[id];
				return {
					id,
					value,
				};
			});
			onSetTestStepAnswers(
				TEST_STEPS.ORDKJEDETESTEN,
				formattedResults,
				candidateGrade
			)
				.then(() => {
					if (!this.state.isSubmitting) {
						this.setState({isSubmitting: true});
						onSetIsSendingTestResultsToFalse();
						onGoToNextStep();
					}
				})
				.catch(() => {
					this.setState({isSubmitting: false});
				});
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;

		const CurrentSubStep = subSteps[currentSubstepIndex];

		return (
			<div className="lit-avatar-test">
				{this.state.showAvatar && (
					<div className="avatar-img">
						<img className="adminItem" src={ordkjedeAvatar}></img>
					</div>
				)}
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					onShowAvatar={(flag) => {
						this.setState({showAvatar: flag});
					}}
					isDldTest={this.props.isDldTest}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
	onSetIsSendingTestResultsToFalse: setIsSendingTestResultsToFalse,

};

export default connect(mapStateToProps, mapDispatchToProps)(Ordkjedetesten);
